export default __webpack_public_path__ + "static/media/exterior1.1af68fff.webp";